import { useCallback, useEffect, useState } from 'react';
import { api, formatTarih } from '../lib/api';

type Kayit = {
  id: number; action: string; entity: string; entityId: string | null;
  kullanici: string; oncesi: unknown; sonrasi: unknown;
  ip: string | null; createdAt: string;
};
type Veri = {
  kayitlar: Kayit[]; toplam: number; sayfa: number; sayfaAdedi: number;
  varliklar: { entity: string; adet: number }[];
  kullanicilar: { id: number; name: string }[];
};

/**
 * KAYIT İZİ (şartname 4.7 + 6).
 *
 * "TÜM yazma uçları middleware ile loglanır (before/after)." Bu ekran onu
 * okunur hâle getiriyor: kim, ne zaman, neyi, neyden neye değiştirdi.
 */
export default function KayitIzi() {
  const [kullanici, setKullanici] = useState('');
  const [entity, setEntity] = useState('hepsi');
  const [ara, setAra] = useState('');
  const [baslangic, setBaslangic] = useState('');
  const [bitis, setBitis] = useState('');
  const [sayfa, setSayfa] = useState(1);
  const [veri, setVeri] = useState<Veri | null>(null);
  const [acik, setAcik] = useState<number | null>(null);
  const [hata, setHata] = useState<string | null>(null);

  const yukle = useCallback(() => {
    const q = new URLSearchParams({
      sayfa: String(sayfa), entity,
      ...(kullanici ? { kullanici } : {}),
      ...(ara ? { ara } : {}),
      ...(baslangic ? { baslangic } : {}),
      ...(bitis ? { bitis } : {}),
    });
    api<Veri>(`/api/kayit-izi?${q}`).then(setVeri).catch((e) => setHata((e as Error).message));
  }, [sayfa, entity, kullanici, ara, baslangic, bitis]);
  useEffect(() => {
    const t = setTimeout(yukle, ara ? 250 : 0);
    return () => clearTimeout(t);
  }, [yukle, ara]);

  // Süzgeç değişince sayfa başa dönsün.
  useEffect(() => { setSayfa(1); }, [entity, kullanici, ara, baslangic, bitis]);

  if (hata && !veri) {
    return <div className="ccd-banner ccd-banner-danger"><span className="ccd-banner-icon">!</span><span>{hata}</span></div>;
  }

  return (
    <>
      <div>
        <h1 className="ccd-title">Kayıt İzi</h1>
        <div className="ccd-meta">
          {veri ? `${veri.toplam.toLocaleString('tr-TR')} kayıt` : '…'} ·
          her yazma işlemi öncesi/sonrası ile saklanır
        </div>
      </div>

      <div className="ccd-card">
        <div className="ccd-form-grid">
          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="kiara">İşlem ara</label>
            <input id="kiara" className="ccd-input" placeholder="teklif.kaydet, stok…"
                   value={ara} onChange={(e) => setAra(e.target.value)} />
          </div>
          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="kikul">Kullanıcı</label>
            <select id="kikul" className="ccd-select" value={kullanici}
                    onChange={(e) => setKullanici(e.target.value)}>
              <option value="">Hepsi</option>
              {veri?.kullanicilar.map((k) => <option key={k.id} value={k.id}>{k.name}</option>)}
            </select>
          </div>
        </div>
        <div className="ccd-form-grid">
          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="kient">Tablo</label>
            <select id="kient" className="ccd-select" value={entity}
                    onChange={(e) => setEntity(e.target.value)}>
              <option value="hepsi">Hepsi</option>
              {veri?.varliklar.map((v) => (
                <option key={v.entity} value={v.entity}>{v.entity} ({v.adet})</option>
              ))}
            </select>
          </div>
          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="kibas">Başlangıç</label>
            <input id="kibas" className="ccd-input" type="date" value={baslangic}
                   onChange={(e) => setBaslangic(e.target.value)} />
          </div>
          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="kibit">Bitiş</label>
            <input id="kibit" className="ccd-input" type="date" value={bitis}
                   onChange={(e) => setBitis(e.target.value)} />
          </div>
        </div>
      </div>

      {!veri ? (
        <div className="ccd-inline-note">Yükleniyor…</div>
      ) : veri.kayitlar.length === 0 ? (
        <div className="ccd-empty">Bu süzgeçte kayıt yok.</div>
      ) : (
        <>
          <div className="ccd-table-wrap">
            <table className="ccd-table">
              <thead>
                <tr>
                  <th className="ccd-th">Zaman</th>
                  <th className="ccd-th">Kullanıcı</th>
                  <th className="ccd-th">İşlem</th>
                  <th className="ccd-th">Kayıt</th>
                  <th className="ccd-th">Detay</th>
                </tr>
              </thead>
              <tbody>
                {veri.kayitlar.map((k) => (
                  <tr key={k.id} className="ccd-tr">
                    <td className="ccd-td ccd-meta ccd-td-nowrap">{formatTarih(k.createdAt)}</td>
                    <td className="ccd-td">{k.kullanici}</td>
                    <td className="ccd-td ccd-mono">{k.action}</td>
                    <td className="ccd-td ccd-meta">
                      {k.entity}{k.entityId ? ` #${k.entityId}` : ''}
                    </td>
                    <td className="ccd-td">
                      {(k.oncesi || k.sonrasi) ? (
                        <button className="ccd-btn ccd-btn-ghost ccd-btn-sm"
                                onClick={() => setAcik(acik === k.id ? null : k.id)}>
                          {acik === k.id ? 'Gizle' : 'Göster'}
                        </button>
                      ) : <span className="ccd-muted">—</span>}
                      {acik === k.id && (
                        <div className="ccd-stack-sm" style={{ marginTop: 8 }}>
                          {k.oncesi != null && (
                            <div>
                              <div className="ccd-field-label">Öncesi</div>
                              <pre className="ccd-mono ccd-meta" style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                                {JSON.stringify(k.oncesi, null, 1)}
                              </pre>
                            </div>
                          )}
                          {k.sonrasi != null && (
                            <div>
                              <div className="ccd-field-label">Sonrası</div>
                              <pre className="ccd-mono ccd-meta" style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                                {JSON.stringify(k.sonrasi, null, 1)}
                              </pre>
                            </div>
                          )}
                          {k.ip && <div className="ccd-meta">IP: {k.ip}</div>}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {veri.sayfaAdedi > 1 && (
            <div className="ccd-row-between">
              <button className="ccd-btn ccd-btn-sm" disabled={sayfa <= 1}
                      onClick={() => setSayfa((s) => s - 1)}>← Önceki</button>
              <span className="ccd-meta">{sayfa} / {veri.sayfaAdedi}</span>
              <button className="ccd-btn ccd-btn-sm" disabled={sayfa >= veri.sayfaAdedi}
                      onClick={() => setSayfa((s) => s + 1)}>Sonraki →</button>
            </div>
          )}
        </>
      )}
    </>
  );
}
